module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('server-side-data-table', {
    attrs: {
      "url": this.url,
      "columns": this.columns,
      "extras-column-name": _vm.trans('columns.actions'),
      "storage-key": "companies-index"
    },
    scopedSlots: _vm._u([{
      key: "extras",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', {
          staticClass: "btn-group"
        }, [(_vm.canEdit()) ? _c('a', {
          staticClass: "btn btn-secondary btn-sm",
          staticStyle: {
            "min-width": "10rem"
          },
          attrs: {
            "href": _vm.route('users.index', {
              company: row.data.id
            })
          }
        }, [_c('i', {
          staticClass: "fa fa-users"
        }), _vm._v(" " + _vm._s(_vm.trans('messages.edit_users')) + "\n            (" + _vm._s(row.data.users_count) + ")\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canEdit()) ? _c('a', {
          staticClass: "btn btn-info btn-sm",
          attrs: {
            "href": _vm.route('companies.trainings.edit', row.data.id)
          }
        }, [_c('i', {
          staticClass: "fa fa-book"
        }), _vm._v(" " + _vm._s(_vm.trans('messages.companytrainings')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canEdit()) ? _c('a', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "href": _vm.route('companies.edit', row.data.id)
          }
        }, [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v(" " + _vm._s(_vm.trans('messages.edit')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canEdit()) ? _c('a', {
          staticClass: "btn btn-warning btn-sm",
          attrs: {
            "href": _vm.route('companies.update_logo', row.data.id)
          }
        }, [_c('i', {
          staticClass: "fa fa-image"
        }), _vm._v(" " + _vm._s(_vm.trans('messages.edit_logo')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.canDelete()) ? _c('button', {
          staticClass: "btn btn-danger btn-sm",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.deleteCompany(row.data.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        }), _vm._v(" " + _vm._s(_vm.trans('messages.delete')) + "\n        ")]) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47c3527c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Companies.vue
// module id = 107
// module chunks = 0